import { Routes, Route, Navigate } from "react-router-dom";
import { useState, useEffect } from "react";
import axiosInstance from "../../utils/axiosInstance";
import { API_ENDPOINTS } from "../../constants/config";
import { TeacherSidebar } from "../../Sidebar/teacher-sidebar";
import FeatureGuard from "../../components/FeatureGuard";
import TeacherAttendance from "../Teacher/Teacherattedenceandleave/Teachertab-teacher-attendance";
import TeacherLeaveApplication from "../Teacher/Teacherattedenceandleave/Teacher-leave-application";
import ClassTeacherStudentManagement from "../Teacher/StudentMapping/ClassTeacherStudentManagement";
import { LeaveApplicationList } from "../Teacher/Studentattendenceandleave/LeaveApplicationList";
import AnnouncementList from "../Common/AnnouncementList";
import BusTrackingMap from "../Common/BusTrackingMap";
import MyProfile from "../Teacher/MyProfile";
import DashboardContent from "../schoolAdmin/DashboardContent";
import StudentsContent from "../schoolAdmin/student/StudentsContent";
import TeachersContent from "../schoolAdmin/teacher/TeachersContent";
import StaffContent from "../schoolAdmin/staff/StaffContent";
import TeacherAttendanceContent from "../schoolAdmin/TeacherAttendenceandleave/TeacherAttendance";
import RegistrationFacesContent from "../schoolAdmin/RegistrationFaces/RegistrationFacesContent";
import PayrollLayout from "../schoolAdmin/Payroll/PayrollLayout";
import PayrollSlipsContent from "../schoolAdmin/Payroll/PayrollSlipsContent";
import LeaveTypesManagement from "../schoolAdmin/Payroll/LeaveTypesManagement";
import SalaryConfigContent from "../schoolAdmin/Payroll/SalaryConfigContent";
import LeaveBalance from "../schoolAdmin/Payroll/LeaveBalance";
import AllowanceDeductionList from "../schoolAdmin/Payroll/AllowanceDeductionList";
import EmployeeSalarySummary from "../schoolAdmin/Payroll/EmployeeSalarySummary";
import ClassTransition from "../schoolAdmin/Transition/ClassTransition";
import ClassroomMapping from "../schoolAdmin/Classroommapping/ClassroomMapping";
import FeeManagementContent from "../schoolAdmin/FeeManagment/FeeManagementContent";
import BusContent from "../schoolAdmin/Bus/BusContent";
import VenndorContent from "../schoolAdmin/InventoryManagment/VenndorContent";
import AssetsManagement from "../schoolAdmin/InventoryManagment/AssetsManagement";
import InventoryManagement from "../schoolAdmin/InventoryManagment/InventoryManagement";
import InventoryReports from "../schoolAdmin/InventoryManagment/InventoryReports";
import InventoryItemDetails from "../schoolAdmin/InventoryManagment/InventoryItemDetails";
import InventorySettings from "../schoolAdmin/InventoryManagment/InventorySettings";
import InventoryImportExport from "../schoolAdmin/InventoryManagment/InventoryImportExport";
import InventoryAllTransactions from "../schoolAdmin/InventoryManagment/InventoryAllTransactions";
import AnnouncementsContent from "../schoolAdmin/Announcement/AnnouncementsContent";
import HolidayScheduler from "../schoolAdmin/HolidayScheduler";
import AlertManagement from "../schoolAdmin/AlertManagment/AlertManagement";
import SettingsContent from "../schoolAdmin/Settings/SettingsContent";
import FAQContent from "../schoolAdmin/FAQ/FAQContent";

export default function TeacherDashboardRouter() {
  const [loading, setLoading] = useState(true);
  const [schoolSettings, setSchoolSettings] = useState(null);
  const token = localStorage.getItem("token");

  useEffect(() => {
    async function fetchSettings() {
      const token = localStorage.getItem("token");
      const userStr = localStorage.getItem("user");
      if (!token || !userStr) return;
      try {
        setLoading(true);
        const res = await axiosInstance.get(API_ENDPOINTS.schoolAbout);
        setSchoolSettings(res.data.data.settings);
      } catch (error) {
        console.error("Error fetching school settings:", error);
      } finally {
        setLoading(false);
      }
    }
    fetchSettings();
  }, []);

  if (loading) {
    return (
      <div className="flex items-center justify-center h-64">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-500"></div>
        <span className="ml-2">Loading...</span>
      </div>
    );
  }

  return (
    <Routes>
      <Route path="/" element={<TeacherSidebar schoolSettings={schoolSettings} />}>
        <Route index element={<Navigate to="/dashboard/leave" replace />} />
        <Route path="my-attendance" element={<TeacherAttendance />} />
        <Route path="leave" element={<TeacherLeaveApplication />} />
        <Route path="class-students" element={<ClassTeacherStudentManagement />} />
        <Route path="student-leave" element={<LeaveApplicationList />} />
        <Route path="announcements" element={<AnnouncementList />} />
        <Route path="profile" element={<MyProfile />} />
        <Route path="bustracking" element={<FeatureGuard feature="busManagement"><BusTrackingMap token={token} /></FeatureGuard>} />
        <Route path="bustracking-teacher" element={<FeatureGuard feature="busManagement"><BusTrackingMap token={token} /></FeatureGuard>} />
        <Route path="live-tracking" element={<FeatureGuard feature="busManagement"><BusTrackingMap token={token} /></FeatureGuard>} />
        <Route path="dashboard" element={<FeatureGuard feature="dashboard"><DashboardContent /></FeatureGuard>} />
        <Route path="students" element={<FeatureGuard feature="students"><StudentsContent /></FeatureGuard>} />
        <Route path="students/:studentName" element={<FeatureGuard feature="students"><StudentsContent /></FeatureGuard>} />
        <Route path="teachers" element={<FeatureGuard feature="teachers"><TeachersContent /></FeatureGuard>} />
        <Route path="teachers/:teacherName" element={<FeatureGuard feature="teachers"><TeachersContent /></FeatureGuard>} />
        <Route path="staff" element={<FeatureGuard feature="staff"><StaffContent /></FeatureGuard>} />
        <Route path="staff/:staffName" element={<FeatureGuard feature="staff"><StaffContent /></FeatureGuard>} />
        <Route path="teacher-attendance" element={<FeatureGuard feature="teacherAttendance"><TeacherAttendanceContent /></FeatureGuard>} />
        <Route path="registration-faces" element={<FeatureGuard feature="registrationFaces"><RegistrationFacesContent /></FeatureGuard>} />
        <Route path="payroll" element={<FeatureGuard feature="payroll"><PayrollLayout /></FeatureGuard>}>
          <Route index element={<Navigate to="/dashboard/payroll/payslip" replace />} />
          <Route path="payslip" element={<PayrollSlipsContent />} />
          <Route path="leave-types" element={<LeaveTypesManagement />} />
          <Route path="salary-structure" element={<SalaryConfigContent />} />
          <Route path="leave-balance" element={<LeaveBalance />} />
          <Route path="allowance-deduction" element={<AllowanceDeductionList />} />
          <Route path="salary-summary" element={<EmployeeSalarySummary />} />
        </Route>
        <Route path="class-transition" element={<FeatureGuard feature="classTransition"><ClassTransition /></FeatureGuard>} />
        <Route path="classroom-mapping" element={<FeatureGuard feature="classroomMapping"><ClassroomMapping /></FeatureGuard>} />
        <Route path="fee-management" element={<FeatureGuard feature="feeManagement"><FeeManagementContent /></FeatureGuard>} />
        <Route path="bus-routes" element={<FeatureGuard feature="busManagement"><BusContent /></FeatureGuard>} />
        <Route path="vendor" element={<FeatureGuard feature="vendor"><VenndorContent /></FeatureGuard>} />
        <Route path="assets" element={<FeatureGuard feature="assets"><AssetsManagement /></FeatureGuard>} />
        <Route path="inventory" element={<FeatureGuard feature="inventory"><InventoryManagement /></FeatureGuard>} />
        <Route path="inventory/reports" element={<FeatureGuard feature="inventory"><InventoryReports /></FeatureGuard>} />
        <Route path="inventory/all-transaction" element={<FeatureGuard feature="inventory"><InventoryAllTransactions /></FeatureGuard>} />
        <Route path="inventory/:id" element={<FeatureGuard feature="inventory"><InventoryItemDetails /></FeatureGuard>} />
        <Route path="inventory/settings" element={<FeatureGuard feature="inventory"><InventorySettings /></FeatureGuard>} />
        <Route path="inventory/settings/import-export" element={<FeatureGuard feature="inventory"><InventoryImportExport /></FeatureGuard>} />
        <Route path="announcements-admin" element={<FeatureGuard feature="announcements"><AnnouncementsContent /></FeatureGuard>} />
        <Route path="holiday" element={<FeatureGuard feature="holidays"><HolidayScheduler /></FeatureGuard>} />
        <Route path="alert" element={<FeatureGuard feature="alerts"><AlertManagement /></FeatureGuard>} />
        <Route path="settings/*" element={<SettingsContent />} />
        <Route path="faq" element={<FeatureGuard feature="faq"><FAQContent /></FeatureGuard>} />
        <Route path="*" element={<Navigate to="/dashboard/leave" replace />} />
      </Route>
    </Routes>
  );
}
